// extracted by mini-css-extract-plugin
export default {"mainSection":"admintemplate_mainSection__h5QEA","container":"admintemplate_container__xxwOi","row":"admintemplate_row__j1EDc"};